import PolyMaps from '../geometric/model/PolyMaps';
import Exporter from '../geometric/tool/Exporter';
import * as THREE from 'three';

const ThreeExport = {

    NoIndices: 0,
    SimpleIndices: 1,
    CompactIndices: 2,

    exportBufferGeometry: function (
            polyMesh, indicesMode, interleaved, exportTangents, oldMesh, prevTriangulation, prevIndexing, prevValueMap) {

        var result = new THREE.BufferGeometry(),
            exportSpec = [],
            { exporter, triangulationChanged } = ThreeExport._prepare(polyMesh,
                                                                      exportSpec,
                                                                      indicesMode,
                                                                      interleaved,
                                                                      exportTangents,
                                                                      oldMesh,
                                                                      prevTriangulation,
                                                                      prevIndexing),

            IdPositions = PolyMaps.IdPositions,
            valueMap = {};

        if (indicesMode !== ThreeExport.NoIndices) {

          var indices = indicesMode === ThreeExport.SimpleIndices ?
                  exporter.getTriangulatingIndices() :
                  exporter.getMapIndices(IdPositions);

          result.setIndex(new THREE.BufferAttribute(indices, 1, false));
        }

        if (!interleaved) {

          for (var i = 0; i !== exportSpec.length; ++i) {

            //console.log(indicesMode);

            var attrSpec = exportSpec[i],

                triangulateValues =
                        indicesMode === ThreeExport.NoIndices;

            var data;
            var newMap = PolyMaps.resolveMap(polyMesh, attrSpec.mapId),
            oldMap = oldMesh && PolyMaps.resolveMap(oldMesh, attrSpec.mapId);

            if (oldMap !== newMap || !prevValueMap) {
              data = indicesMode !== ThreeExport.CompactIndices ?

                          exporter.getUnindexedMapValues(
                                  attrSpec.mapId, triangulateValues) :

                          exporter.getMapValues(attrSpec.mapId);
            } else {
              //console.log('skip');
              data = prevValueMap[attrSpec.mapId];
            }

            valueMap[attrSpec.mapId] = data;
            result.addAttribute(attrSpec.threeName,
                    new THREE.BufferAttribute(
                        data, attrSpec.itemSize, attrSpec.normalized));
          }

        } else {

          var stride = 0;
          for (var i = 0; i !== exportSpec.length; ++i)
              stride += exportSpec[i].itemSize;

          var nValuess = 0;
          switch (indicesMode) {

            case ThreeExport.NoIndices: // no. of triangulated vertices
              nValuess = exporter.getNumFaceVertices();
              break;

            case ThreeExport.SimpleIndices: // no. of values
              nValuess = exporter.mesh.getNumFaceVertices();
              break;

            case ThreeExport.CompactIndices: // as calculated
              nValuess = exporter.
                      getNumMapValues(PolyMaps.IdPositions);
          }

          var data = new Float32Array(stride * nValuess),
              buffer = new THREE.InterleavedBuffer(data, stride),

              offset = 0;

          for (var i = 0; i !== exportSpec.length; ++i) {

            var attrSpec = exportSpec[i],
                itemSize = attrSpec.itemSize,
                mapId = attrSpec.mapId;

            if (indicesMode !== ThreeExport.CompactIndices) {

              exporter.getUnindexedMapValues(mapId,
                      indicesMode === ThreeExport.NoIndices,
                      data, offset, stride);

            } else {

              exporter.getMapValues(mapId, data, offset, stride);
            }

            result.addAttribute(attrSpec.threeName,
                    new THREE.InterleavedBufferAttribute(
                                            buffer, itemSize, offset));

            offset += itemSize;
          }
        }
        // add group to buffer geometry if there is materialId list in polymesh
        var groups = exporter.getGroups();
        if (polyMesh.materialIds && groups) {
          for (var i = 0; i < groups.groupCounts.length; i++) {
            if(groups.groupCounts[i] > 0) {
              result.addGroup(groups.groupStarts[i], groups.groupCounts[i], i);
            }
          }
        }
        return {
            geometry: result,
            triangulation: exporter.triangulation,
            renderIndexing: exporter.renderIndexing,
            triangulationChanged,
            valueMap,
          };
      },

    _prepare: function (
            polyMesh, outSpec, indicesMode, interleaved, exportTangents, oldMesh, prevTriangulation, prevIndexing) {

        var exporter = new Exporter(polyMesh),
            mapsToExport = [];

        var retriangulate = !oldMesh || !prevTriangulation
            || oldMesh.positions.faceValueIndices !== polyMesh.positions.faceValueIndices;
        var reIndex = !oldMesh || !prevIndexing;

        var mapOffset = 0;
        //console.log(polyMesh);
        for (var iter = new PolyMaps.Iterator(polyMesh); iter.next();) {

          var threeName = '',
              itemSize = 3,
              normalized = false;

          switch (iter.typeId) {

          case PolyMaps.TypePosition:
            threeName = 'position';
            break;

          case PolyMaps.TypeTangent:
            // Note: Since tangents are normally ignored by the three.js
            // renderer, they must be requested explicitly.
            if (!exportTangents) break;
            threeName = 'tangent';
            break;

          case PolyMaps.TypeNormal:
            threeName = 'normal';
            break;

          case PolyMaps.TypeUV:
            if (iter.index >= 2) break; // max two UV maps
            threeName = 'uv' + (
                    iter.index !== 0 ? iter.index + 1 : '');
            itemSize = 2;
            break;

          case PolyMaps.TypeColor:

            if (iter.index >= 1) break; // use first color map
            threeName = 'color';
            normalized = true;

        }

          if (!threeName || (interleaved && normalized)) continue;

          var mapId = iter.getId();
          mapsToExport.push(mapId);

          outSpec.push({
              mapId: mapId,
              threeName: threeName,
              itemSize: itemSize,
              normalized: normalized,
            });
          ++mapOffset;

        }

        for (var i = 0; i < outSpec.length && !reIndex; i++) {
          var oldMap = PolyMaps.resolveMap(oldMesh, outSpec[i].mapId),
          newMap = PolyMaps.resolveMap(polyMesh, outSpec[i].mapId);
          if (oldMap.faceValueIndices !== newMap.faceValueIndices) reIndex = true;
        }

        //console.log(polyMesh===(prevData && prevData.mesh));
        if (indicesMode === ThreeExport.CompactIndices && !reIndex) {
          prevIndexing.mesh = polyMesh;
          exporter.renderIndexing = prevIndexing;
        } else if (indicesMode === ThreeExport.CompactIndices && reIndex) {

          exporter.reindexForRendering(mapsToExport);
        }

        var triangulationChanged = false;
        if (retriangulate) {
          exporter.triangulate();
          triangulationChanged = true;
        } else {
          exporter.triangulation = prevTriangulation;
        }

        return { exporter, triangulationChanged };
      },

  };

export default ThreeExport;



// WEBPACK FOOTER //
// ./src/polyMesh/three/ThreeExport.js